"use strict";

var _toConsumableArray = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _objectSpread = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateTransaction = void 0;

var lisk_validator_1 = require("@liskhq/lisk-validator");

var schema_1 = require("./schema");

var validateTransaction = function validateTransaction(assetSchema, transactionObject) {
  var transactionObjectWithEmptyAsset = _objectSpread({}, transactionObject, {
    asset: Buffer.alloc(0)
  });

  var schemaErrors = lisk_validator_1.validator.validate(schema_1.baseTransactionSchema, transactionObjectWithEmptyAsset);

  if (schemaErrors.length) {
    return new lisk_validator_1.LiskValidationError(_toConsumableArray(schemaErrors));
  }

  if (typeof transactionObject.asset !== 'object' || transactionObject.asset === null) {
    return new Error('Transaction object asset must be of type object and not null');
  }

  var assetSchemaErrors = lisk_validator_1.validator.validate(assetSchema, transactionObject.asset);

  if (assetSchemaErrors.length) {
    return new lisk_validator_1.LiskValidationError(_toConsumableArray(assetSchemaErrors));
  }

  return undefined;
};

exports.validateTransaction = validateTransaction;